"use strict";

System.register("app.bootstrap", [], function (_export, _context) {
    return {
        setters: [],
        execute: function () {
            /* global document */

            System.import("app.module").then(function () {
                return angular.element(document).ready(function () {
                    return angular.bootstrap(document, ["app"]);
                });
            });
        }
    };
});
"use strict";

System.register("app.config", [], function (_export, _context) {
    return {
        setters: [],
        execute: function () {
            _export("default", function ($compileProvider) {
                "ngInject";

                $compileProvider.debugInfoEnabled(false);
            });
        }
    };
});
"use strict";

System.register("app.module", ["core/core.module", "widgets/widgets.module", "layout/layout.module", "home/home.module", "app.config", "app.templates", "app.route"], function (_export, _context) {
    var CoreModule, WidgetsModule, LayoutModule, HomeModule, disableDebugInfo, loadTemplates, RouteController;
    return {
        setters: [function (_coreCoreModule) {
            CoreModule = _coreCoreModule.default;
        }, function (_widgetsWidgetsModule) {
            WidgetsModule = _widgetsWidgetsModule.default;
        }, function (_layoutLayoutModule) {
            LayoutModule = _layoutLayoutModule.default;
        }, function (_homeHomeModule) {
            HomeModule = _homeHomeModule.default;
        }, function (_appConfig) {
            disableDebugInfo = _appConfig.default;
        }, function (_appTemplates) {
            loadTemplates = _appTemplates.default;
        }, function (_appRoute) {
            RouteController = _appRoute.default;
        }],
        execute: function () {
            _export("default", angular.module("app", [

            /* shared modules */
            CoreModule.name, WidgetsModule.name,

            /* feature areas */
            LayoutModule.name, HomeModule.name]).config(disableDebugInfo).run(loadTemplates).controller("RouteController", RouteController));
        }
    };
});
"use strict";

System.register("app.route", [], function (_export, _context) {
    var RouteController;

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    return {
        setters: [],
        execute: function () {
            RouteController = function RouteController($router) {
                "ngInject";

                _classCallCheck(this, RouteController);

                $router.config([{
                    path: "/",
                    component: "home"
                }]);
            };

            _export("default", RouteController);
        }
    };
});
"use strict";

System.register("core/core.material.config", [], function (_export, _context) {
    return {
        setters: [],
        execute: function () {
            _export("default", function ($mdThemingProvider) {
                "ngInject";

                $mdThemingProvider.theme("default").primaryPalette("brown", {
                    "default": "500",
                    "hue-1": "100",
                    "hue-2": "700",
                    "hue-3": "900"
                }).accentPalette("deep-orange", {
                    "default": "A200",
                    "hue-1": "A100",
                    "hue-2": "A400",
                    "hue-3": "A700"
                }).warnPalette("amber", {
                    "default": "500",
                    "hue-1": "100",
                    "hue-2": "700",
                    "hue-3": "900"
                });
            });
        }
    };
});
"use strict";

System.register("core/core.module", ["core/core.router.config", "core/core.material.config"], function (_export, _context) {
    var routerConfig, materialConfig;
    return {
        setters: [function (_coreCoreRouterConfig) {
            routerConfig = _coreCoreRouterConfig.default;
        }, function (_coreCoreMaterialConfig) {
            materialConfig = _coreCoreMaterialConfig.default;
        }],
        execute: function () {
            _export("default", angular.module("app.core", [

            /* angular modules */
            "ngNewRouter", "ngMaterial"

            /* 3rd-party modules */

            /* cross-app modules */
            ]).config(routerConfig).config(materialConfig));
        }
    };
});
"use strict";

System.register("core/core.router.config", [], function (_export, _context) {
    var camelToDash;
    return {
        setters: [],
        execute: function () {
            camelToDash = function camelToDash(name) {
                var UPPERCASE = /([A-Z])/g;
                var upperCaseToDashLowerCase = function upperCaseToDashLowerCase($1) {
                    return "-" + $1.toLowerCase();
                };

                return name.replace(UPPERCASE, upperCaseToDashLowerCase);
            };

            _export("default", function ($componentLoaderProvider) {
                "ngInject";

                $componentLoaderProvider.setTemplateMapping(function (name) {
                    return "app/" + camelToDash(name) + "/" + camelToDash(name) + ".html";
                });
            });
        }
    };
});
"use strict";

System.register("home/home.controller", [], function (_export, _context) {
    var _createClass, HomeController;

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    return {
        setters: [],
        execute: function () {
            _createClass = function () {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }

                return function (Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();

            HomeController = function () {
                function HomeController() {
                    _classCallCheck(this, HomeController);
                }

                _createClass(HomeController, [{
                    key: "activate",
                    value: function activate() {
                        this.minNbOfRecipes = 10;
                    }
                }]);

                return HomeController;
            }();

            _export("default", HomeController);
        }
    };
});
"use strict";

System.register("home/home.module", ["home/home.controller"], function (_export, _context) {
    var HomeController;
    return {
        setters: [function (_homeHomeController) {
            HomeController = _homeHomeController.default;
        }],
        execute: function () {
            _export("default", angular.module("app.home", []).controller("HomeController", HomeController));
        }
    };
});
"use strict";

System.register("layout/layout.module", [], function (_export, _context) {
    return {
        setters: [],
        execute: function () {
            _export("default", angular.module("app.layout", []));
        }
    };
});
"use strict";

System.register("widgets/widgets.module", [], function (_export, _context) {
    return {
        setters: [],
        execute: function () {
            _export("default", angular.module("app.widgets", []));
        }
    };
});
"use strict";

System.register("app.templates", [], function (_export, _context) {
  return {
    setters: [],
    execute: function () {
      _export("default", function ($templateCache) {
        "ngInject";

        $templateCache.put("app/home/home.html", "<span id=\"number-recipes\">Op deze pagina zullen binnenkort minstens {{home.minNbOfRecipes}} recepten staan.</span>");
        $templateCache.put("app/layout/layout.shell.html", "<div layout=\"column\"layout-fill>\n<md-toolbar md-scroll-shrink=\"false\">\n<div class=\"md-toolbar-tools\">\n<span>Frontend food</span>\n</div>\n</md-toolbar>\n<md-content layout-padding>\n<div ng-viewport></div>\n</md-content>\n</div>");
      });
    }
  };
});